module.exports = __webpack_public_path__ + "img/apd.8e13eeaf.jpg";